import { useTranslation } from "react-i18next";

import {
  Stepper,
  StepperIndicator,
  StepperItem,
  StepperSeparator,
  StepperTitle,
  StepperTrigger,
} from "@/components/ui/stepper";

import { useMediaQuery } from "@/hooks/use-media-query";

import { cn } from "@/lib/utils";

export const Steps = ({
  currentStep,
  className,
}: {
  currentStep: number;
  className?: string;
}) => {
  const { t } = useTranslation();

  const isMobile = useMediaQuery("(max-width: 640px)");

  const steps = [
    {
      step: 1,
      title: t("steps.1"),
    },
    {
      step: 2,
      title: t("steps.2"),
    },
    {
      step: 3,
      title: t("steps.3"),
    },
  ];

  return (
    <Stepper
      className={className}
      orientation={isMobile ? "vertical" : "horizontal"}
      value={currentStep}
    >
      {steps.map(({ step, title }) => (
        <StepperItem
          className={cn(
            isMobile
              ? "relative not-last:flex-1 items-start"
              : "not-last:flex-1 max-md:items-start"
          )}
          key={step}
          step={step}
        >
          <StepperTrigger
            className={cn(
              isMobile
                ? "items-start rounded pb-12 last:pb-0"
                : "rounded max-md:flex-col"
            )}
          >
            <StepperIndicator />
            <div
              className={cn(
                isMobile ? "mt-0.5 px-2 text-left" : "text-center md:text-left"
              )}
            >
              <StepperTitle>{title}</StepperTitle>
            </div>
          </StepperTrigger>
          {step < steps.length && (
            <StepperSeparator
              className={cn(
                isMobile
                  ? "absolute inset-y-0 top-[calc(2rem+0.125rem)] left-4 -order-1 m-0 -translate-x-1/2 group-data-[orientation=vertical]/stepper:h-[calc(100%-2rem-0.25rem)] group-data-[orientation=horizontal]/stepper:w-[calc(100%-1.5rem-0.25rem)] group-data-[orientation=horizontal]/stepper:flex-none"
                  : "max-md:mt-3.5 md:mx-4"
              )}
            />
          )}
        </StepperItem>
      ))}
    </Stepper>
  );
};
